import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './components/auth/Login';
import NetlifyBypassLogin from './components/auth/NetlifyBypassLogin';
import Register from './components/auth/Register';
import Dashboard from './components/dashboard/Dashboard';
import ReportsPage from './components/reports/ReportsPage';
import ReportDetail from './components/reports/ReportDetail';
import StaticReports from './components/reports/StaticReports';
import MarchReportStandalone from './components/reports/MarchReportStandalone';
import PerfectMarchReport from './components/reports/PerfectMarchReport';
import StandaloneMarchReport from './components/reports/StandaloneMarchReport';
import StandaloneJanuaryReport from './components/reports/StandaloneJanuaryReport';
import StandaloneFebruaryReport from './components/reports/StandaloneFebruaryReport';
import StandaloneAprilReport from './components/reports/StandaloneAprilReport';
import StandaloneMayReport from './components/reports/StandaloneMayReport';
import StandaloneCCAprilReport from './components/reports/StandaloneCCAprilReport';
import StandaloneCCJanuaryReport from './components/reports/StandaloneCCJanuaryReport';
import StandaloneCCFebruaryReport from './components/reports/StandaloneCCFebruaryReport';
import StandaloneCCMarchReport from './components/reports/StandaloneCCMarchReport';
import StandaloneCCMayReport from './components/reports/StandaloneCCMayReport';
import StandaloneCCQ1Report from './components/reports/StandaloneCCQ1Report';
import StandaloneQ1Report from './components/reports/StandaloneQ1Report';
import StandaloneJuneReport from './components/reports/StandaloneJuneReport';
import StandaloneCCJuneReport from './components/reports/StandaloneCCJuneReport';
import StandaloneQ2Report from './components/reports/StandaloneQ2Report';
import StandaloneCCQ2Report from './components/reports/StandaloneCCQ2Report';
import StandaloneQ3Report from './components/reports/StandaloneQ3Report';
import StandaloneQ4Report from './components/reports/StandaloneQ4Report';
import StandaloneJulyReport from './components/reports/StandaloneJulyReport';
import StandaloneCCJulyReport from './components/reports/StandaloneCCJulyReport';
import StandaloneAugustReport from './components/reports/StandaloneAugustReport';
import StandaloneCCAugustReport from './components/reports/StandaloneCCAugustReport';
import StandaloneSeptemberReport from './components/reports/StandaloneSeptemberReport';
import StandaloneCCSeptemberReport from './components/reports/StandaloneCCSeptemberReport';
import StandaloneOctoberReport from './components/reports/StandaloneOctoberReport';
import StandaloneNovemberReport from './components/reports/StandaloneNovemberReport';
import StandaloneDecemberReport from './components/reports/StandaloneDecemberReport';
import StandaloneCCOctoberReport from './components/reports/StandaloneCCOctoberReport';
import StandaloneCCNovemberReport from './components/reports/StandaloneCCNovemberReport';
import StandaloneCCDecemberReport from './components/reports/StandaloneCCDecemberReport';
import StandaloneCCQ3Report from './components/reports/StandaloneCCQ3Report';
import StandaloneCCQ4Report from './components/reports/StandaloneCCQ4Report';
import StandaloneYTDReport from './components/reports/StandaloneYTDReport';
import StandaloneCCYTDReport from './components/reports/StandaloneCCYTDReport';
import StandaloneJanuary2026Report from './components/reports/StandaloneJanuary2026Report';
import StandaloneFebruary2026Report from './components/reports/StandaloneFebruary2026Report';
import StandaloneCCJanuary2026Report from './components/reports/StandaloneCCJanuary2026Report';
import StandaloneCCFebruary2026Report from './components/reports/StandaloneCCFebruary2026Report';
import StandaloneCCMarch2026Report from './components/reports/StandaloneCCMarch2026Report';
import StandaloneCCApril2026Report from './components/reports/StandaloneCCApril2026Report';
import StandaloneCCMay2026Report from './components/reports/StandaloneCCMay2026Report';
import StandaloneCCJune2026Report from './components/reports/StandaloneCCJune2026Report';
import StandaloneCCJuly2026Report from './components/reports/StandaloneCCJuly2026Report';
import StandaloneMarch2026Report from './components/reports/StandaloneMarch2026Report';
import StandaloneApril2026Report from './components/reports/StandaloneApril2026Report';
import StandaloneMay2026Report from './components/reports/StandaloneMay2026Report';
import StandaloneJune2026Report from './components/reports/StandaloneJune2026Report';
import StandaloneJuly2026Report from './components/reports/StandaloneJuly2026Report';
import StandaloneQ1_2026Report from './components/reports/StandaloneQ1_2026Report';
import StandaloneCCQ1_2026Report from './components/reports/StandaloneCCQ1_2026Report';
import StandaloneQ2_2026Report from './components/reports/StandaloneQ2_2026Report';
import StandaloneCCQ2_2026Report from './components/reports/StandaloneCCQ2_2026Report';
import StandaloneYTD2026Report from './components/reports/StandaloneYTD2026Report';
import StandaloneCCYTD2026Report from './components/reports/StandaloneCCYTD2026Report';
import ProtectedRoute from './components/routing/ProtectedRoute';
import LandingPage from './components/landing/LandingPage';
import AdminDashboard from './components/admin/AdminDashboard';
import CSVReportGenerator from './components/admin/CSVReportGenerator';
import ReportManager from './components/admin/ReportManager';
import BusinessRulesManager from './components/admin/BusinessRulesManager';
import JobEditor from './components/admin/JobEditor';
import RuleUpgradeManager from './components/admin/RuleUpgradeManager';
import GeneratedReportViewer from './components/reports/GeneratedReportViewer';
import Navbar from './components/layout/Navbar';
import CSVUploadPage from './components/upload/CSVUploadPage';
import SimplifiedCSVUploadPage from './components/upload/SimplifiedCSVUploadPage';
import EnhancedCSVUploadPage from './components/upload/EnhancedCSVUploadPage';
import StreamingCSVUploadPage from './components/upload/StreamingCSVUploadPage';
import Unauthorized from './components/common/Unauthorized';
import AuthTest from './components/debug/AuthTest';
import GenerateReportPage from './pages/GenerateReportPage';
import SavedReportsPage from './pages/SavedReportsPage';
import './App.css';

function App() {
  // Detect if this is a Netlify deployment
  const isNetlifyDeployment = 
    window.location.hostname.includes('netlify.app') || 
    window.location.hostname.includes('github.io') || 
    window.location.hostname.includes('reporting.roiconstruction.com') ||
    process.env.REACT_APP_USE_MOCK_DATA === 'true' ||
    process.env.REACT_APP_NETLIFY === 'true';

  return (
    <Router>
      <AuthProvider>
        <div className="App bg-gray-50 min-h-screen">
          <Navbar />
          <div className="page-container">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={isNetlifyDeployment ? <NetlifyBypassLogin /> : <Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/auth-test" element={<AuthTest />} />
              
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute component={Dashboard} />
                }
              />
              
              <Route
                path="/reports"
                element={
                  <ProtectedRoute component={ReportsPage} />
                }
              />
              
              <Route
                path="/reports/:id"
                element={
                  <ProtectedRoute component={ReportDetail} />
                }
              />
              
              <Route
                path="/upload"
                element={
                  <ProtectedRoute component={CSVUploadPage} />
                }
              />
              
              <Route
                path="/upload-simplified"
                element={
                  <ProtectedRoute component={SimplifiedCSVUploadPage} />
                }
              />
              
              <Route
                path="/upload-enhanced"
                element={
                  <ProtectedRoute component={EnhancedCSVUploadPage} />
                }
              />
              
              <Route
                path="/upload-streaming"
                element={
                  <ProtectedRoute component={StreamingCSVUploadPage} />
                }
              />
              
              <Route
                path="/admin"
                element={
                  <ProtectedRoute component={AdminDashboard} requiredRole="admin" />
                }
              />
              
              <Route
                path="/admin/csv-generator"
                element={
                  <ProtectedRoute component={CSVReportGenerator} requiredRole="admin" />
                }
              />
              
              <Route
                path="/admin/reports"
                element={
                  <ProtectedRoute component={ReportManager} requiredRole="admin" />
                }
              />
              
              <Route
                path="/admin/business-rules"
                element={
                  <ProtectedRoute component={BusinessRulesManager} requiredRole="admin" />
                }
              />
              
              <Route
                path="/admin/rule-upgrades"
                element={
                  <ProtectedRoute component={RuleUpgradeManager} requiredRole="admin" />
                }
              />
              
              <Route
                path="/reports/:id/edit"
                element={
                  <ProtectedRoute component={JobEditor} />
                }
              />
              
              <Route
                path="/reports/generated/:reportId"
                element={
                  <ProtectedRoute component={GeneratedReportViewer} />
                }
              />
              
              {/* Generate Report - CSV upload wizard */}
              <Route
                path="/generate-report"
                element={<GenerateReportPage />}
              />

              {/* Saved Reports - Manage localStorage reports */}
              <Route
                path="/saved-reports"
                element={<SavedReportsPage />}
              />

              {/* Static reports pages - no API calls */}
              <Route
                path="/static-reports"
                element={<StaticReports />}
              />
              
              {/* Perfect March report that matches screenshot */}
              <Route
                path="/perfect-march-report"
                element={<PerfectMarchReport />}
              />
              
              {/* Standalone March report using the dashboard MarketingReport component */}
              <Route
                path="/dashboard-march-report"
                element={<StandaloneMarchReport />}
              />
              
              {/* Redirect old /march-report URL to the dashboard version */}
              <Route
                path="/march-report"
                element={<Navigate to="/dashboard-march-report" replace />}
              />
              
              {/* Standalone January report using January data */}
              <Route
                path="/january-report"
                element={<StandaloneJanuaryReport />}
              />
              
              {/* Standalone February report using February data */}
              <Route
                path="/february-report"
                element={<StandaloneFebruaryReport />}
              />
              
              {/* Standalone Q1 report with consolidated data */}
              <Route
                path="/q1-report"
                element={<StandaloneQ1Report />}
              />
              
              {/* Standalone April report using April data */}
              <Route
                path="/april-report"
                element={<StandaloneAprilReport />}
              />
              
              {/* Cody's Direct Sales April report */}
              <Route
                path="/cc-april-report"
                element={<StandaloneCCAprilReport />}
              />
              
              {/* Cody's Direct Sales January report */}
              <Route
                path="/cc-january-report"
                element={<StandaloneCCJanuaryReport />}
              />
              
              {/* Cody's Direct Sales February report */}
              <Route
                path="/cc-february-report"
                element={<StandaloneCCFebruaryReport />}
              />
              
              {/* Cody's Direct Sales March report */}
              <Route
                path="/cc-march-report"
                element={<StandaloneCCMarchReport />}
              />
              
              {/* Cody's Direct Sales Q1 Consolidated report */}
              <Route
                path="/cc-q1-report"
                element={<StandaloneCCQ1Report />}
              />
              
              {/* Standalone May report using May data */}
              <Route
                path="/may-report"
                element={<StandaloneMayReport />}
              />
              
              {/* Cody's Direct Sales May report */}
              <Route
                path="/cc-may-report"
                element={<StandaloneCCMayReport />}
              />
              
              {/* Standalone June report using June data */}
              <Route
                path="/june-report"
                element={<StandaloneJuneReport />}
              />
              
              {/* Cody's Direct Sales June report */}
              <Route
                path="/cc-june-report"
                element={<StandaloneCCJuneReport />}
              />
              
              {/* Standalone Q2 report with consolidated data */}
              <Route
                path="/q2-report"
                element={<StandaloneQ2Report />}
              />
              
              {/* Cody's Direct Sales Q2 Consolidated report */}
              <Route
                path="/cc-q2-report"
                element={<StandaloneCCQ2Report />}
              />

              {/* Standalone Q3 report with consolidated data */}
              <Route
                path="/q3-report"
                element={<StandaloneQ3Report />}
              />

              {/* Standalone Q4 report with consolidated data */}
              <Route
                path="/q4-report"
                element={<StandaloneQ4Report />}
              />

              {/* Standalone July report using July data */}
              <Route
                path="/july-report"
                element={<StandaloneJulyReport />}
              />
              <Route
                path="/august-report"
                element={<StandaloneAugustReport />}
              />
              <Route
                path="/september-report"
                element={<StandaloneSeptemberReport />}
              />
              <Route
                path="/october-report"
                element={<StandaloneOctoberReport />}
              />
              <Route
                path="/november-report"
                element={<StandaloneNovemberReport />}
              />
              <Route
                path="/december-report"
                element={<StandaloneDecemberReport />}
              />

              {/* Cody's Direct Sales July report */}
              <Route
                path="/cc-july-report"
                element={<StandaloneCCJulyReport />}
              />

              {/* Cody's Direct Sales August report */}
              <Route
                path="/cc-august-report"
                element={<StandaloneCCAugustReport />}
              />

              {/* Cody's Direct Sales September report */}
              <Route
                path="/cc-september-report"
                element={<StandaloneCCSeptemberReport />}
              />

              {/* Cody's Direct Sales October report */}
              <Route
                path="/cc-october-report"
                element={<StandaloneCCOctoberReport />}
              />

              {/* Cody's Direct Sales November report */}
              <Route
                path="/cc-november-report"
                element={<StandaloneCCNovemberReport />}
              />

              {/* Cody's Direct Sales December report */}
              <Route
                path="/cc-december-report"
                element={<StandaloneCCDecemberReport />}
              />

              {/* Cody's Direct Sales Q3 Consolidated report */}
              <Route
                path="/cc-q3-report"
                element={<StandaloneCCQ3Report />}
              />

              {/* Cody's Direct Sales Q4 Consolidated report */}
              <Route
                path="/cc-q4-report"
                element={<StandaloneCCQ4Report />}
              />

              {/* Year-to-Date Reports */}
              <Route
                path="/ytd-report"
                element={<StandaloneYTDReport />}
              />
              <Route
                path="/cc-ytd-report"
                element={<StandaloneCCYTDReport />}
              />

              {/* January 2026 Reports */}
              <Route
                path="/january-2026-report"
                element={<StandaloneJanuary2026Report />}
              />
              <Route
                path="/february-2026-report"
                element={<StandaloneFebruary2026Report />}
              />
              <Route
                path="/cc-january-2026-report"
                element={<StandaloneCCJanuary2026Report />}
              />
              <Route
                path="/cc-february-2026-report"
                element={<StandaloneCCFebruary2026Report />}
              />
              <Route
                path="/cc-march-2026-report"
                element={<StandaloneCCMarch2026Report />}
              />
              <Route
                path="/cc-april-2026-report"
                element={<StandaloneCCApril2026Report />}
              />
              <Route
                path="/cc-may-2026-report"
                element={<StandaloneCCMay2026Report />}
              />
              <Route
                path="/cc-june-2026-report"
                element={<StandaloneCCJune2026Report />}
              />
              <Route
                path="/cc-july-2026-report"
                element={<StandaloneCCJuly2026Report />}
              />
              <Route
                path="/march-2026-report"
                element={<StandaloneMarch2026Report />}
              />
              <Route
                path="/april-2026-report"
                element={<StandaloneApril2026Report />}
              />
              <Route
                path="/may-2026-report"
                element={<StandaloneMay2026Report />}
              />
              <Route
                path="/june-2026-report"
                element={<StandaloneJune2026Report />}
              />
              <Route
                path="/july-2026-report"
                element={<StandaloneJuly2026Report />}
              />
              <Route
                path="/q1-2026-report"
                element={<StandaloneQ1_2026Report />}
              />
              <Route
                path="/cc-q1-2026-report"
                element={<StandaloneCCQ1_2026Report />}
              />
              <Route
                path="/q2-2026-report"
                element={<StandaloneQ2_2026Report />}
              />
              <Route
                path="/cc-q2-2026-report"
                element={<StandaloneCCQ2_2026Report />}
              />
              <Route
                path="/ytd-2026-report"
                element={<StandaloneYTD2026Report />}
              />
              <Route
                path="/cc-ytd-2026-report"
                element={<StandaloneCCYTD2026Report />}
              />
            </Routes>
          </div>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;